import React from 'react'
import Helmet from 'react-helmet'
import 'styles/main.scss'
import Header from 'components/header'
import Footer from 'components/footer'
import Player from 'components/player'
import Message from 'components/message'
import { GlobalStateProvider } from 'utils/hooks/globalStateProvider'

function LayoutClassic(props) {
  const {
    children,
    title = '',
    description = '',
    thumbnail,
    dataFooter,
    dataHeader,
    headerIsDark = false,
    headerIsTransparent = false,
    headerNoSticky = false,
    footerIsDark = false,
    pageClassName = '',
    footerVideo,
    footerVideoTitle,
    footerVideoDescription,
  } = props

  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const href = typeof window !== 'undefined' ? window.location.href : ''
  const defaultShareUrl = `${origin}/images/share-default.jpg`.replace('//images', '/images')

  if (typeof window !== 'undefined') {
    if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) {
      document.querySelector('body').classList.add('is-safari')
    }
  }

  return (
    <>
      <Helmet>
        <html lang="en" />

        <link rel="icon" href="/images/favicons/favicon.svg" />
        <link rel="apple-touch-icon" sizes="180x180" href="/images/favicons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/images/favicons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/images/favicons/favicon-16x16.png" />
        <link rel="manifest" href="/images/favicons/site.webmanifest" />
        <link rel="mask-icon" href="/images/favicons/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff"></meta>

        <meta name="robots" content="index, follow" />
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta property="image" content={thumbnail || defaultShareUrl} />

        <meta name="og:type" prefix="og: http://ogp.me/ns#" content="website" />
        <meta property="og:title" prefix="og: http://ogp.me/ns#" content={title} />
        <meta property="og:description" prefix="og: http://ogp.me/ns#" content={description} />
        <meta property="og:url" prefix="og: http://ogp.me/ns#" content={href} />
        <meta property="og:image" content={thumbnail || defaultShareUrl} />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:creator" content="@Qovery_" />
        <meta property="twitter:url" content={href} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={thumbnail || defaultShareUrl} />

        {href.length > 0 ? <link rel="canonical" href={href} /> : null}

        <title>{title}</title>

        <script async src="/scripts/intercom.js" type="text/javascript" />
        <script async src="/scripts/lf.js" type="text/javascript" />
        <script async src="/scripts/gt.js" type="text/javascript" />
        <script async src="/scripts/ph.js" type="text/javascript" />
        <script
          type="text/javascript"
          id="hs-script-loader"
          async
          defer
          src="//js-eu1.hs-scripts.com/25346960.js"
        ></script>
      </Helmet>
      <Header
        data={dataHeader}
        headerIsDark={headerIsDark}
        headerNoSticky={headerNoSticky}
        headerIsTransparent={headerIsTransparent}
      />
      <GlobalStateProvider>
        <div className={`page ${pageClassName}`}>{children}</div>
        <div className="page-opacity"></div>
        <Player />
        <Message />
      </GlobalStateProvider>
      <Footer
        data={dataFooter}
        footerIsDark={footerIsDark}
        footerVideoTitle={footerVideoTitle}
        footerVideoDescription={footerVideoDescription}
        video={footerVideo}
      />
    </>
  )
}

export default LayoutClassic
